import { transtaion } from './config';

class Translation {
    constructor() {
        const key = localStorage.getItem('translation_key') ?? 'en';
        this.translation = transtaion[key];
    }

    getTranslation() {
        return this.translation;
    }

    getValueByStringKey(key) {
        return key.split('.').reduce((acc, part) => acc && acc[part], this.translation);
    }

    t(key) {
        const value = this.getValueByStringKey(key);
        return value;
    }

    changeLanguage(key) {
        this.translation = transtaion[key];
        localStorage.setItem('translation_key', key);
    }
}

export const translationInit = new Translation();
export const t = (key) => translationInit.t(key);
export const changeLanguage = (key) => translationInit.changeLanguage(key);
